import { Component, Input } from '@angular/core';
import { DateService } from '../../common/date.service';

import { FiltersComponent } from '../../common/filters.component';

@Component({
	selector: 'app-season-filters',
	templateUrl: './season-filters.component.html',
	styleUrls: ['./season-filters.component.css'],
})
export class SeasonFiltersComponent extends FiltersComponent {
	private readonly date = new DateService();

	filters = {
		name: null,
		departureFromFirstStop_from: null,
		departureFromFirstStop_to: null,
		arrivalAtDestination_from: null,
		arrivalAtDestination_to: null,
		saleClosingDate_from: null,
		saleClosingDate_to: null,
		confirmDeadline_from: null,
		confirmDeadline_to: null,
		status: [],
		owner: null,
		kind: [],
	};

	protected filtersDefinition = {
		status: {
			type: 'string',
			isArray: true,
		},
		owner: {
			type: 'string',
			isArray: false,
		},
		kind: {
			type: 'string',
			isArray: true,
		},
	};

	@Input() statuses: Array<any>;
	@Input() users: Array<any>;
	@Input() kinds: Array<any>;

	protected filtersAfterLoad() {
		const date = new Date();
		let changed = false;
		if (
			!this.filters.departureFromFirstStop_from &&
			!this.filters.arrivalAtDestination_from &&
			!this.filters.saleClosingDate_from &&
			!this.filters.confirmDeadline_from
		) {
			this.filters.departureFromFirstStop_from = this.date.toUtcDate(date);
			changed = true;
		}
		if (
			!this.filters.departureFromFirstStop_to &&
			!this.filters.arrivalAtDestination_to &&
			!this.filters.saleClosingDate_to &&
			!this.filters.confirmDeadline_to
		) {
			date.setDate(date.getDate() + 30);
			this.filters.departureFromFirstStop_to = this.date.toUtcDate(date);
			changed = true;
		}
		if (changed) {
			this.filtersSave();
		}
	}
}
